const utils = {
    findFromList: findFromList,
    numberFormat: numberFormat,
    copyObject: copyObject,
    getFileExtension: getFileExtension,
    getProductCode: getProductCode
};

function findFromList(list, keyword) {
    return list.filter((el) => search(el, keyword));
}

function numberFormat(number){
    let int = new Intl.NumberFormat();
    return int.format(number);
}

function copyObject(obj){
    if (obj != null) {
        return JSON.parse(JSON.stringify(obj));
    }
}

function getFileExtension(filename){
    return filename.substring(filename.lastIndexOf(".")+1);
}

//Code produit Syteline du projet d'une NC (tickets #58, #64).
//Département d'abord, sinon modèle. Le 1er caractère porte la rive : 0 = Rive Nord, 2 = Rive Sud.
function getProductCode(nonConformite, modelName) {
    const departementCodes = {
        '6-43': '0QAL.ENT61',
        '6-44': '0QAL.LOC61',
        '6-45': '0QAL.LOC65',
        '6-48': '1QAL.LOC65',
        '1-46': '0QAL.SAV25',
        '1-47': '0QAL.SAV61'
    };
    const modelsWithCode = ['SAM450', 'SAM575', 'SL075', 'SL100', 'SL225', 'SL260', 'SL320', 'SP100', 'ST100'];

    let productCode = departementCodes[nonConformite.ncParentDepartementId + '-' + nonConformite.ncDepartementId];
    if (!productCode) {
        if (modelsWithCode.includes(modelName)) {
            productCode = '0QAL' + modelName;
        }
        else if (modelName === 'SEA') {
            productCode = '0QALSEA775';
        }
        else {
            productCode = '0Qualite';
        }
    }

    //Les codes qui commencent par autre chose (1QAL.LOC65 = USA) ne sont pas touchés.
    if (nonConformite.locationNc === 'rive_sud' && productCode.startsWith('0')) {
        productCode = '2' + productCode.substring(1);
        //Syteline nomme les SAM Rive Sud 2QALSM450 / 2QALSM575 (2QALSAM… n'existe pas)
        productCode = productCode.replace(/^2QALSAM/, '2QALSM');
    }

    return productCode;
}

function search(el, keyword) {
    const type = Array.isArray(el) ? 'array' : typeof el;

    if( el === null){
        return false;
    }
    switch (type) {
        case 'string':
            return searchInText(el, keyword);
        case 'number':
            return searchInText(el, keyword);
        case 'boolean':
            return searchInText(el, keyword);
        case 'array':
            return searchInArray(el, keyword);
        case 'object':
            return searchInObject(el, keyword);
        default:
            return false;
    }
}

function searchInText(text, keyword) {
    return (text.toString().toLowerCase().indexOf(keyword) !== -1);
}

function searchInObject(obj, keyword) {
    return searchInArray(Object.values(obj), keyword);
}
function searchInArray(arr, keyword) {
    return arr.find((el) => search(el, keyword)) !== undefined;
}

export default utils;
